<template>
    <div id="clients-components-canceled">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="dependent in dependents">
                                    <td>{{ dependent.nombre }} {{ dependent.paterno }} {{ dependent.materno }}</td>
                                    <td>
                                        <div class="dropdown">
                                            <button class="btn btn-warning dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                <i class="fas fa-cogs"></i>
                                            </button>
                                            <div v-if="dependent.deleted_at!=null" class="dropdown-menu"
                                                 aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                   v-on:click="restoreDependent(dependent.id)">
                                                    Restaurar
                                                </a>
                                            </div>
                                            <div v-else class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                   v-on:click="cancelDependent(dependent.id)">
                                                    Cancelar
                                                </a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row ">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination
                                pills
                                align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3" v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                            <select v-model="client_id_selected" @change="getTrashedAffiliates()">
                                <option :value="0">Selecciona un Cliente</option>
                                <option v-for="client in clients" :value="client.sku">
                                   <span v-if="client.tipo_per===1">
                                       {{ client.sku }} - {{ client.nombre }} {{ client.paterno }} {{ client.materno }}
                                   </span>
                                    <span v-else>
                                        {{ client.sku }} - {{ client.nmComPerMoral }}
                                    </span>
                                </option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <select class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Afiliado)="{item}">

                                {{ item.nombre }} {{ item.paterno }} {{ item.materno }}

                            </template>
                            <template #cell(Sku)="{item}">
                                {{ item.sku }}
                            </template>
                            <template #cell(Status)="{item}">
                                <span v-if="item.approved_at==''"
                                      class="badge rounded-pill text-bg-danger">Pendiente</span>
                                <span v-if="item.approved_at!=''&&item.canceled_at==''"
                                      class="badge rounded-pill text-bg-success">Contratado</span>
                                <span v-if="item.canceled_at!=''"
                                      class="badge rounded-pill text-bg-danger">Cancelado</span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="restoreClientAffiliate(item.id)">
                                            Restaurar
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="getDependents(item.sku)">
                                            Ver Dependientes
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page" :total-rows="pagination.total"
                                          :per-page="pagination.per_page" aria-controls="my-table"
                                          v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {clientsService} from "../../Services/Clients.service";
import {affiliateTitularsService} from "../../Services/AffiliateTitularsService";
import {affiliatedependentsService} from "../../Services/AffiliateDependents.service";

export default {
    name: "clients",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            person: false,
            filter: null,
            params: {
                limit: 10,
                page: 1,
                sku: 0,
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Afiliado'},
                {key: 'Sku'},
                {key: 'Status'},
                {key: 'Acciones'}
            ],
            tituloBtn: 'Agregar',
            itemId: 0,
            client_id_selected: 0,
            clients: [],
            dependents: [],
        }
    },
    methods: {

        async getDependents(id) {
            this.openModalsProviders();
            this.dependents = await affiliatedependentsService.getDependentsByTitular(id);
        },

        async restoreDependent(id) {
            let resp = await affiliatedependentsService.restoreDependent(id);
            this.getAlert(resp.process, true);
        },

        async cancelDependent(id) {
            let resp = await affiliatedependentsService.cancelDependent(id);
            this.getAlert(resp.process,true);
        },

        async getTrashedAffiliates() {
            this.isBusy = true;
            this.params.sku = this.client_id_selected;
            //console.log('params get - ',this.params);
            // Agrega el número de página como un parámetro de URL
            this.pagination = await affiliateTitularsService.getTrashedAffiliates(this.params);
            this.isBusy = false;
        },

        async restoreClientAffiliate(id) {
            let resp = await affiliateTitularsService.restoreTitular(id);
            this.getAlert(resp.process);
            await this.getTrashedAffiliates();
        },

        async index() {
            this.isBusy = true;
            this.clients = await clientsService.getMany();
            this.isBusy = false;
        },

        async onChange(page) {
            //console.log('page onchange - ',page)
            this.params.page = page;
            await this.getTrashedAffiliates();
        },
        async changeLimit() {
            await this.getTrashedAffiliates();
        },

    },
    mounted() {
        this.index();
    }
}
</script>
